<template>
  <b-card no-body>
    <b-card-body>
      <provider-region-detail
        ref="providerRegionDetail"
        type="new"
        :submitting="submitting"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import ProviderRegionDetail from '@/views/pages/providers/ProviderRegionDetail.vue';

export default {
  components: {
    BCard,
    BCardBody,
    ProviderRegionDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      data: {}
    };
  },
  methods: {
    submit(data) {
      const request = {};

      const id = parseInt(this.$route.params.id);
      request.provider = id;

      let countries;

      if (Array.isArray(data.countries)) {
        countries = data.countries.map(element => element.value);
      } else if (data.countries && typeof data.countries === 'object') {
        countries = [data.countries.value];
      } else {
        countries = [];
      }

      request.countries = countries;

      request.name = data.name;

      this.submitting = true;
      useService
        .createProviderRegion(request)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({
            name: 'customer_regions_list',
            params: { id: this.$route.params.id }
          });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
